import script from "./IssueConceptEditCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssueConceptEditCard.vue?vue&type=script&lang=ts&setup=true"

import "./IssueConceptEditCard.vue?vue&type=style&index=0&id=d2754b6e&lang=scss&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2754b6e"]])

export default __exports__